import React from 'react';
import { useFormContext } from 'react-hook-form';

import { DocumentController } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';
import type { TFileAttached } from '@/types/financing';

import {
  type FormType,
  fileDict,
  type fileDictType
} from '../../features/euras-bank';

const HIDE_STATUSES = [
  'financed',
  'financed_pledge_missing',
  'financed_waiting_for_modification_before_pledge'
];

interface IProps {
  files: TFileAttached[];
}

const EurasThirdStep: React.FC<IProps> = ({ files }) => {
  const { selectedBank } = useAppSelector((state) => state.financingStep);
  const { control } = useFormContext<FormType>();

  const shouldHideEditableFields = HIDE_STATUSES.includes(
    selectedBank?.status.code || ''
  );

  return files?.map((file, index) => {
    const itemClassName = shouldHideEditableFields
      ? 'financing-step__field'
      : 'financing-step__field--half';

    if (index < 2) return null;
    return (
      <React.Fragment key={file.uuid}>
        <DocumentController
          title={fileDict[file.type as fileDictType] || ''}
          fileLink={file.uuid}
          downloadable
          wrapperClassName={itemClassName}
        />
        <DocumentController
          control={control}
          name={file.type}
          title={`${fileDict[file.type as fileDictType] || ''} (подписан)`}
          uploadable
          isRequired
          visiable={!shouldHideEditableFields}
          wrapperClassName={itemClassName}
        />
      </React.Fragment>
    );
  });
};

export default EurasThirdStep;
